<template>
  <div class="diy-alerts__item-details">
    <UserAvatar :tooltip="false" :user="activity.user" />
    <!-- main content -->
    <div class="diy-alerts__item-details-content">
      <div class="diy-alerts__item-details-action">
        <span>{{ userFullName }}</span>
        <AppIcon :icon="actionIcon" />
        <span v-markdown="actionText" class="diy-alerts__item-details-title"></span>
      </div>
      <!-- date -->
      <div class="diy-alerts__item-details-date">
        {{ $d(new Date(activity.created), 'short', currentUser.language) }}
      </div>
      <div v-if="isComment" class="diy-alerts__item-details-text">{{ activity.message }}</div>
    </div>
  </div>
</template>

<script>
// Utilities
import AlertIconType from 'Mixins/AlertIconType'
// Component
import AppIcon from 'Ui/AppIcon'
import UserAvatar from 'Components/UserAvatar'

export default {
  name: 'AlertsItemDetails',

  components: {
    AppIcon,
    UserAvatar,
  },

  props: {
    activity: {
      type: Object,
      required: true,
    },
  },

  mixins: [AlertIconType],

  computed: {
    currentUser() {
      return this.$store.state.user.currentUser
    },

    isComment() {
      return this.activity.type === 'comment'
    },

    userFullName() {
      const user = this.activity.user
      return `${user.first_name} ${user.last_name}`
    },

    actionText() {
      let action = ''
      let actionType = this.activity.type

      if (actionType === 'comment') action = this.$t('card_modal.ui.activity_comment_action')
      if (actionType !== 'comment') action = this.activity.title
      return action
    },
  },
}
</script>

<style scoped>
.diy-alerts__item-details {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 0.625rem;
  padding: 0.625rem;
  gap: 0.9375rem;
  width: 100%;
  color: var(--c-secondary);
}

.diy-alerts__item-details-content {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 0.3125rem;
}

.diy-alerts__item-details-date {
  display: inline-block;
  align-self: flex-start;
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 1rem;
  letter-spacing: 0.5px;
  color: var(--c-primary);
  border-radius: 2px;
  background-color: var(--c-secondary-500);
  padding: 4px 5px;
  text-transform: uppercase;
  text-decoration: none;
}

.diy-alerts__item-details-action {
  word-break: break-word;
}

.diy-alerts__item-details-action span:first-of-type {
  font-weight: 600;
  color: var(--c-primary);
}

.diy-alerts__item-details-action .app-icon {
  margin: 0 0.375rem 0 0.375rem;
}

.diy-alerts__item-details-title >>> * {
  display: inline;
  color: var(--c-secondary);
}

.diy-alerts__item-details-text {
  grid-row: 2;
  grid-column: span 3;
  font-size: 14px;
  line-height: 20px;
  color: var(--c-primary);
  border-radius: 4px;
  border: 1px solid var(--c-secondary-500);
  margin-top: 0.3125rem;
  background-color: var(--c-secondary-200);
  padding: 15px 20px;
  box-shadow: 0 1px 2px -1px var(--rgba--light-blue-300);
}
</style>
